import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeGetSalesChannelParams, TypeGetSalesChannelResponse } from '~/types/product.types';

/**
 * [상품관리] 상품 판매처 매핑 리스트 조회 API
 */
export const fetchSalesChannel = async (params: TypeGetSalesChannelParams): Promise<TypeGetSalesChannelResponse> => {
  const endpoint = '/api-lip/v1/third-parties/sales-channel';
  const { data } = await axiosInstance.get<TypeGetSalesChannelResponse>(endpoint, { params });
  return data;
};

type UseGetSalesChannelQueryOptions = {
  params: TypeGetSalesChannelParams;
  enabled?: boolean;
  showGlobalDimOverlay?: boolean;
};

/**
 * [상품관리] 상품 판매처 매핑 리스트 조회 Query Hook
 */
export const useGetSalesChannelQuery = ({
  params,
  enabled = true,
  showGlobalDimOverlay = true,
}: UseGetSalesChannelQueryOptions) => {
  return useQuery({
    queryKey: productKeys.salesChannel(params),
    queryFn: () => fetchSalesChannel(params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
    meta: { showGlobalDimOverlay },
  });
};
